import React, { useLayoutEffect, useState, useRef } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Animated,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import "../../../../App.scss";

const textColor = "var(--text-color-default)";
const choiceColor = "var(--module-color-exp)";
const choiceActiveTextColor = "var(--module-color-exp-overlay)";
const choiceActiveColor = "var(--module-color-exp-active)";
const Index = (props) => {
  const animation = useRef(new Animated.Value(0)).current;
  const [buttonColor, setButtonColor] = useState(choiceColor);
  const [colorset, setColorset] = useState(0);
  const [hide, setHide] = useState(true);
  const Color = (index) => {
    setHide(true);
    setColorset(index);
    setButtonColor(choiceActiveColor);
    props.selectAnswerHandler(
      props.moduleObject.moduleid,
      props.moduleObject.questions[props.moduleIndex].qid,
      props.moduleObject.questions[props.moduleIndex].answers[index - 1].respid
    );
  };
  useLayoutEffect(() => {
    if (buttonColor === choiceActiveColor) {
      nextPage();
    }
  }, [buttonColor]);

  useLayoutEffect(() => {
    Animated.timing(animation, {
      toValue: 1,
      duration: 1000,
    }).start(() => setHide(false));
  }, []);
  const nextPage = () => {
    Animated.timing(animation, {
      toValue: 0,
      duration: 1000,
    }).start(() => props.Refresh());
  };
  return (
    <Animated.View style={[styles.content, { opacity: animation }]}>
      <Text style={styles.customText}>
        {props.moduleObject.questions[0].text}
      </Text>
      <View style={styles.buttongroup}>
        <View>
          <TouchableOpacity
            onPress={() => {
              Color(1);
            }}
            disabled={hide}
            style={[
              styles.button,
              {
                borderColor: colorset === 1 ? buttonColor : choiceColor,
                backgroundColor: colorset === 1 ? buttonColor : choiceColor,
              },
            ]}
          >
            <Text
              style={[
                styles.buttontext,
                { color: colorset === 1 ? choiceActiveTextColor : textColor },
              ]}
            >
              {props.moduleObject.questions[0].answers[0].text}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{ margin: 5 }}></View>
        <View>
          <TouchableOpacity
            onPress={() => {
              Color(2);
            }}
            disabled={hide}
            style={[
              styles.button,
              {
                borderColor: colorset === 2 ? buttonColor : choiceColor,
                backgroundColor: colorset === 2 ? buttonColor : choiceColor,
              },
            ]}
          >
            <Text
              style={[
                styles.buttontext,
                { color: colorset === 2 ? choiceActiveTextColor : textColor },
              ]}
            >
              {props.moduleObject.questions[0].answers[1].text}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Animated.View>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  customText: {
    position: "relative",
    width:
      Dimensions.get("screen").width > 1300
        ? wp("28%")
        : Dimensions.get("screen").width > 700
        ? wp("42%")
        : wp("89%"),
    Height: hp("24.3%"),
    fontSize:
      Dimensions.get("screen").width > 1000
        ? 24
        : Dimensions.get("screen").width < 350
        ? 16
        : 22,
    textAlign: "center",
    color: textColor,
    marginBottom: hp("4%"),
    fontFamily: "Infra",
    lineHeight:
      Dimensions.get("screen").width > 1000
        ? 32
        : Dimensions.get("screen").width < 350
        ? 24
        : 26,
    fontWeight: "var(--font-weight-semi-bold)",
  },
  button: {
    width:
      Dimensions.get("screen").width > 1000
        ? 144
        : Dimensions.get("screen").width < 350
        ? 88
        : 114,
    height:
      Dimensions.get("screen").width > 1000
        ? 144
        : Dimensions.get("screen").width < 350
        ? 88
        : 114,
    borderWidth: 3,
    borderRadius:
      Dimensions.get("screen").width > 1000
        ? 72
        : Dimensions.get("screen").width < 350
        ? 44
        : 57,
    borderStyle: "solid",
    borderColor: choiceColor,
    backgroundColor: choiceColor,
    alignItems: "center",
    justifyContent: "center",
  },
  buttontext: {
    fontFamily: "Infra",
    fontSize:
      Dimensions.get("screen").width > 1000
        ? 20
        : Dimensions.get("screen").width < 350
        ? 11.3
        : 14.6,
    textAlign: "center",
    color: textColor,
    fontWeight: "var(--font-weight-semi-bold)",
    lineHeight:
      Dimensions.get("screen").width > 1000
        ? 28
        : Dimensions.get("screen").width < 350
        ? 15.8
        : 20.5,
    padding:
      Dimensions.get("screen").width > 1000
        ? 10
        : Dimensions.get("screen").width < 350
        ? 10
        : 10,
  },
  buttongroup: {
    flexDirection: "row",
  },
});
